import { render, staticRenderFns } from "./slist.vue?vue&type=template&id=31881c27&scoped=true&"
import script from "./slist.vue?vue&type=script&lang=js&"
export * from "./slist.vue?vue&type=script&lang=js&"
import style0 from "./slist.vue?vue&type=style&index=0&id=31881c27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31881c27",
  null
  
)

export default component.exports